import { gql } from '@apollo/client';

export const RECOMMENDATION_DEFINITIONS_FRAGMENT = gql`
    fragment RecommendationDefinitions on RecommendationDefinitions {
        scoringFactors {
            code
            displayName
            description
            sortIndex
        }
        hardConstraints {
            code
            displayName
            description
        }
    }
`;

export const CLINICIAN_RECOMMENDATION_ITEM_FRAGMENT = gql`
    fragment ClinicianRecommendationItem on ClinicianRecommendationItem {
        rank
        clinician {
            id
            fullName
            externalIds {
                value
            }
        }
        scoringFactors {
            code
            sortValue
            displayValue
        }
        earnedBadges {
            code
            displayName
            relativeDescriptor
        }
    }
`;

export const DATE_RECOMMENDATION_ITEM_FRAGMENT = gql`
    fragment DateRecommendationItem on DateRecommendationItem {
        rank
        date
        scoringFactors {
            code
            sortValue
            displayValue
        }
        earnedBadges {
            code
            displayName
            relativeDescriptor
        }
    }
`;

export const INCOMPATIBLE_CLINICIAN_RESULT_FRAGMENT = gql`
    fragment IncompatibleClinicianResult on IncompatibleClinicianResult {
        clinician {
            id
            fullName
            externalIds {
                value
            }
        }
        hardConstraintResults {
            code
            isSatisfied
        }
    }
`;

export const INCOMPATIBLE_DATE_RESULT_FRAGMENT = gql`
    fragment IncompatibleDateResult on IncompatibleDateResult {
        date
        hardConstraintResults {
            code
            isSatisfied
        }
    }
`;

export const VISIT_REASSIGNMENT_QUERY = gql`
    query VisitReassignmentDialog($input: VisitReassignmentInput!) {
        decisionSupport {
            visitReassignment(input: $input) {
                definitions {
                    clinicianRecommendation {
                        ...RecommendationDefinitions
                    }
                    dateRecommendation {
                        ...RecommendationDefinitions
                    }
                }
                results {
                    visitId
                    clinicianRecommendation {
                        fixedDate
                        recommendations {
                            ...ClinicianRecommendationItem
                        }
                        incompatibleClinicians {
                            ...IncompatibleClinicianResult
                        }
                    }
                    dateRecommendation {
                        fixedClinicianAppointments {
                            clinicianAppointmentId
                            clinicianId
                        }
                        recommendations {
                            ...DateRecommendationItem
                        }
                        incompatibleDates {
                            ...IncompatibleDateResult
                        }
                    }
                }
            }
        }
    }
    ${RECOMMENDATION_DEFINITIONS_FRAGMENT}
    ${CLINICIAN_RECOMMENDATION_ITEM_FRAGMENT}
    ${DATE_RECOMMENDATION_ITEM_FRAGMENT}
    ${INCOMPATIBLE_CLINICIAN_RESULT_FRAGMENT}
    ${INCOMPATIBLE_DATE_RESULT_FRAGMENT}
`;
